rebru.DataTable = function () {
    var defaultoptions = {
        searching: true,
        dom: '<"html5buttons"B>lTfgitp',
        responsive: false,
        scrollX: true,
        scrollCollapse: true,
        select: {
            style: 'multi',
            selector: 'td:first-child'
        },
        order: [[1, 'asc']],
        columnDefs: [
            {
                targets: 0,
                checkboxes: {
                    selectRow: true
                }
            }
        ]
    };

    var intVal = function (i) {
        return typeof i === 'string' ?
            i.replace(/[\$,]/g, '') * 1 :
            typeof i === 'number' ?
                i : 0;
    };

    var appendPaymentTypeSelectorToColumn = function (column) {
        var select = $('<select class="form-control" style="width: 100% padding:4px;"><option value=""></option></select>')
            .appendTo(".dataTables_scrollHeadInner .datatable-filters > .column-" + (column.index() + 1))
            .on('change', function () {
                var val = $.fn.dataTable.util.escapeRegex(
                    $(this).val()
                );
                var data = column.search(val ? '' + val + '' : '').draw();
                data.draw();
            });

        select.append('<option selected value="all">All</option>');
        select.append('<option value="red">Red Slip</option>');
        select.append('<option value="orange">Orange Slip</option>');
        select.append('<option value="qr">Qr Slip</option>');
    };

    var appendPaymentTypeSelectorToColumnByColumnNumber = function (dt, columnNumbers) {
        columnNumbers = Array.isArray(columnNumbers) ? columnNumbers : [columnNumbers];

        dt.columns(columnNumbers).every(function () {
            rebru.DataTable.helpers.appendPaymentTypeSelectorToColumn(this);
        });
    };

    var calculateAndShowPaymentAndFinalAmountInDataTable = function (dt, startingColumn) {
        var paymentAmount = 0;
        var finaAmount = 0;

        dt.columns([startingColumn]).every(function () {
            var column = this;
            paymentAmount = paymentAmount + column.data().reduce(function (a, b) {
                return rebru.DataTable.helpers.intVal(a) + rebru.DataTable.helpers.intVal(b);
            }, 0);
        });


        dt.columns([startingColumn]).every(function () {
            var column = this;
            finaAmount = finaAmount + column.data().reduce(function (a, b) {
                return rebru.DataTable.helpers.intVal(a) + rebru.DataTable.helpers.intVal(b);
            }, 0);
        });


        $(`.dataTables_scrollFoot .footer-column-${startingColumn - 1}`).html("<span class='text-bold float-right'>Total</span>");
        $(`.dataTables_scrollFoot .footer-column-${startingColumn}`).html(paymentAmount.toFixed(2));
        $(`.dataTables_scrollFoot .footer-column-${startingColumn + 1}`).html(finaAmount.toFixed(2));
    };

    var getSelectedIds = function (dt, columnNumber = 1) {
        var rowsSelected = dt.column(columnNumber).checkboxes.selected();

        var selectedIDs = [];

        $.each(rowsSelected, function (index, rowId) {
            selectedIDs.push(rowId);
        });

        return selectedIDs;
    };

    var redrawAndShowSuccess = function (dt, successMessage = "Table refreshed!") {
        location.reload();
        rebru.toastr.publish('success', successMessage);
    };

    var redrawAndShowError = function (dt, successMessage = "Table refreshed!") {
        location.reload();
        rebru.toastr.publish('error', successMessage);
    };

    var hideModalInAjaxCallback = function (modalElementSelector) {
        $(modalElementSelector).modal('hide');
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
    };

    return {
        init: function (elSelector, config, options = {}) {
            return $(elSelector).initDataTables(config, Object.assign(Object.assign({}, defaultoptions), options));
        },
        helpers: {
            intVal: intVal,
            appendPaymentTypeSelectorToColumn: appendPaymentTypeSelectorToColumn,
            appendPaymentTypeSelectorToColumnByColumnNumber: appendPaymentTypeSelectorToColumnByColumnNumber,
            calculateAndShowPaymentAndFinalAmountInDataTable: calculateAndShowPaymentAndFinalAmountInDataTable,
            getSelectedIds: getSelectedIds,
            redrawAndShowSuccess: redrawAndShowSuccess,
            redrawAndShowError: redrawAndShowError,
            hideModalInAjaxCallback: hideModalInAjaxCallback
        }
    };
}();